export default __webpack_public_path__ + "static/dlLiDVXC-0258bcaf97c1f8a04b3afffdc0eb5a4e.svg";